/**
 * CTA « Ajouter au panier » dans la description produit :
 * 1) ajoute la variante sélectionnée via /cart/add.js
 * 2) redirige vers /cart
 * 3) sinon remonte jusqu’au bouton d’achat en haut de fiche
 */
(function () {
  'use strict';

  function rootUrl() {
    try {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    } catch (_) {
      return '/';
    }
  }

  function findVariantId() {
    const scopes = [
      document.querySelector('product-form form[action*="/cart/add"]'),
      document.querySelector('form[action*="/cart/add"]'),
      document.querySelector('form[action$="/cart/add"]'),
      document.getElementById('product-form'),
    ].filter(Boolean);

    for (const form of scopes) {
      const input = form.querySelector('input[name="id"]:not([disabled]), select[name="id"]:not([disabled])');
      const val = input && String(input.value || '').trim();
      if (val && /^\d+$/.test(val)) return val;
    }

    const any = document.querySelector(
      'product-form input[name="id"]:not([disabled]), form[action*="/cart/add"] input[name="id"]:not([disabled])'
    );
    const fallback = any && String(any.value || '').trim();
    return fallback && /^\d+$/.test(fallback) ? fallback : null;
  }

  function findTopBuyButton() {
    return (
      document.querySelector('product-form [name="add"]') ||
      document.querySelector('product-form button[type="submit"]') ||
      document.querySelector('form[action*="/cart/add"] [name="add"]') ||
      document.querySelector('form[action*="/cart/add"] button[type="submit"]') ||
      document.querySelector('.buy-buttons button[type="submit"]') ||
      document.querySelector('[data-product-form] [name="add"]')
    );
  }

  function scrollToTopBuy() {
    const btn = findTopBuyButton();
    const target = btn || document.querySelector('product-form') || document.querySelector('#MainProduct');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      try {
        if (btn && typeof btn.focus === 'function') btn.focus({ preventScroll: true });
      } catch (_) {
        try {
          btn.focus();
        } catch (__) {}
      }
      return true;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return false;
  }

  function addThenCart(variantId) {
    const url = rootUrl().replace(/\/?$/, '/') + 'cart/add.js';
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
      }),
    }).then(function (res) {
      if (!res.ok) throw new Error('add_failed_' + res.status);
      window.location.href = rootUrl().replace(/\/?$/, '/') + 'cart';
    });
  }

  function onCtaClick(event) {
    const link = event.target.closest('a.lgk-desc-cta');
    if (!link) return;

    event.preventDefault();
    event.stopPropagation();

    if (link.getAttribute('aria-busy') === 'true') return;
    link.setAttribute('aria-busy', 'true');
    const prev = link.textContent;
    link.textContent = 'Ajout…';

    const variantId = findVariantId();
    if (!variantId) {
      link.setAttribute('aria-busy', 'false');
      link.textContent = prev;
      scrollToTopBuy();
      return;
    }

    addThenCart(variantId).catch(function () {
      link.setAttribute('aria-busy', 'false');
      link.textContent = prev;
      scrollToTopBuy();
    });
  }

  document.addEventListener('click', onCtaClick, true);
})();
